import { useEffect, useState } from "react";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../config/firebase";

// Bookings come from three different forms (suite/wellness/pavilion), each
// storing the guest name and date(s) under different field names — these
// helpers normalize them for display.
const guestNameOf = (b) => b.primaryGuest || b.guestName1 || b.name || "—";

const dateRangeOf = (b) => {
  if (b.checkIn && b.checkOut) return `${b.checkIn} → ${b.checkOut}`;
  return b.date || "—";
};

export default function AdminBookings() {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const q = query(
          collection(db, "bookings"),
          orderBy("timestamp", "desc")
        );
        const snap = await getDocs(q);
        const data = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        setBookings(data);
      } catch (err) {
        console.error("Error fetching bookings:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchBookings();
  }, []);

  const filtered = filter === "all"
    ? bookings
    : bookings.filter((b) => b.bookingType === filter);

  const statusColor = (status) => {
    if (status === "confirmed") return "#1a7a4a";
    if (status === "pending")   return "#b45309";
    if (status === "completed") return "#1e40af";
    return "#6b7280";
  };

  if (loading) return <p className="admin-loading">Loading bookings...</p>;

  return (
    <div>
      <div className="admin-filter-row">
        {[
          { key: "all",      label: "All"            },
          { key: "suite",    label: "Suites"         },
          { key: "villa",    label: "Villas"         },
          { key: "wellness", label: "Wellness"       },
          { key: "pavilion", label: "PB Pavilion"   },
        ].map(({ key, label }) => (
          <button
            key={key}
            className={`filter-btn ${filter === key ? "active" : ""}`}
            onClick={() => setFilter(key)}
          >
            {label}
          </button>
        ))}
        <span className="booking-count">{filtered.length} bookings</span>
      </div>

      {filtered.length === 0 ? (
        <div className="admin-empty">No bookings found.</div>
      ) : (
        <div className="bookings-table-wrap">
          <table className="bookings-table">
            <thead>
              <tr>
                <th>Guest</th>
                <th>Type</th>
                <th>Date(s)</th>
                <th>Total</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((b) => (
                <tr key={b.id}>
                  <td>{guestNameOf(b)}</td>
                  <td className="type-badge">{b.bookingType || "—"}</td>
                  <td>{dateRangeOf(b)}</td>
                  <td>${typeof b.amountPaid === "number" ? b.amountPaid.toFixed(2) : "—"}</td>
                  <td>
                    <span
                      className="status-pill"
                      style={{ color: statusColor(b.status), borderColor: statusColor(b.status) }}
                    >
                      {b.status || "pending"}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
